import { motion } from "framer-motion";
import { ArrowRight, Lock } from "lucide-react";
import { useDiagnostic } from "./DiagnosticContext";
import { HeroMockup } from "./HeroMockup";

const LINES = ["Turn your technology", "experience into a practical", "AI project you can explain."];
const ease = [0.2, 0.75, 0.15, 1];

const MaskLine = ({ text, i }) => (
  <span className="block overflow-hidden pb-[0.08em]">
    <motion.span className="block" initial={{ y: "105%" }} animate={{ y: 0 }} transition={{ duration: 1, delay: 0.15 + i * 0.12, ease }}>
      {text}
    </motion.span>
  </span>
);

const FadeUp = ({ children, d, className }) => (
  <motion.div className={className} initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8, delay: d, ease }}>
    {children}
  </motion.div>
);

export const Hero = () => {
  const { open } = useDiagnostic();
  return (
    <section data-testid="hero-section" className="hero-bg grain relative overflow-hidden border-b border-slate-200">
      <div className="dot-grid pointer-events-none absolute inset-y-0 right-0 w-1/2 opacity-60 [mask-image:linear-gradient(to_left,black,transparent)]" />
      <div className="relative mx-auto grid max-w-[1360px] items-center gap-10 px-5 pb-14 pt-12 lg:grid-cols-[1.25fr_1fr] lg:px-10 lg:pb-16 lg:pt-14">
        <div>
          <h1 data-testid="hero-title" className="font-display text-[38px] font-extrabold leading-[1.04] tracking-[-0.025em] text-[#0B1B33] sm:text-5xl lg:text-[46px] xl:text-[54px]">
            {LINES.map((l, i) => <MaskLine key={l} text={l} i={i} />)}
          </h1>
          <FadeUp d={0.6}>
            <p className="mt-6 max-w-[560px] text-base leading-relaxed text-slate-700 md:text-lg">
              A guided path to scope, build, test, and explain one bounded, domain-relevant AI project from start to finish.
            </p>
          </FadeUp>
          <FadeUp d={0.75}>
            <button data-testid="hero-cta-btn" onClick={() => open()}
              className="btn-teal mt-8 inline-flex w-full items-center justify-center gap-3 rounded-xl px-7 py-4 text-[16px] font-semibold sm:w-auto sm:text-[17px]">
              Take the 5-Minute Readiness Diagnostic <ArrowRight className="arrow h-5 w-5" />
            </button>
            <p data-testid="hero-guarantee-note" className="mt-4 flex items-start gap-2 text-[14px] text-slate-600">
              <Lock className="mt-0.5 h-4 w-4 shrink-0 text-[#0B1B33]" /> No job or salary guarantees. A practical next step based on your answers.
            </p>
          </FadeUp>
        </div>
        <HeroMockup />
      </div>
    </section>
  );
};
